import { Id, LinkPollStatus } from 'NSwag/ServerClient/Client.nswag';

/**
 * Defines actions that can be performed for the
 * Link Poll Data in the store.
 */
export enum LinkPollDataActionTypes {
    AddLinkPollData  = 'ADD_LINK_POLL_DATA',
    ModifyLinkPollData = 'MODIFY_LINK_POLL_DATA',
    DeleteLinkPollData = 'DELETE_LINK_POLL_DATA'
}

export interface AddLinkPollData {
    type: LinkPollDataActionTypes.AddLinkPollData;
    linkPollData: LinkPollStatus[];
}

export interface ModifyLinkPollData {
    type: LinkPollDataActionTypes.ModifyLinkPollData;
    linkPollData: LinkPollStatus[];
}

export interface DeleteLinkPollData {
    type: LinkPollDataActionTypes.DeleteLinkPollData;
    ids: Id[];
}